import React, { useContext, useState } from 'react';
import { appActions, AppContext } from 'context';
import { NotificationObject } from 'models/notificationObject';
import { NotificationType } from 'common/enums';
import { ModalChooseGuestType } from './components/modal-choose-guest-type';
import { ModalInviteUsers } from './components/modal-invite-users';
import { ModalInviteConfirmation } from './components/modal-invite-confirmation';

type InviteToRecordProcessProps = {
  handleClose: () => void;
  handleFinishProcess?: () => void;
  initialStep?: InvitationStep;
  withVaultSelection?: boolean;
  preselectedVault?: SelectType;
};

export enum InvitationStep {
  chooseGuestType = 'chooseGuestType',
  inviteContributors = 'inviteContributors',
  inviteContributorsConfirmation = 'inviteContributorsConfirmation',
  inviteGuests = 'inviteGuests',
  inviteGuestsConfirmation = 'inviteGuestsConfirmation',
}

const InviteToRecordProcess: React.FC<InviteToRecordProcessProps> = ({
  handleClose,
  initialStep,
  handleFinishProcess,
  withVaultSelection = false,
  preselectedVault,
}) => {
  const { dispatch } = useContext(AppContext);

  const [step, setStep] = useState(
    initialStep ?? InvitationStep.chooseGuestType,
  );

  const showSuccessToast = () =>
    dispatch({
      type: appActions.NOTIFICATION,
      notification: new NotificationObject({
        show: true,
        title: 'Invitation(s) sent',
        type: NotificationType.Success,
      }),
    });

  const handleBack =
    initialStep === InvitationStep.chooseGuestType || !initialStep
      ? () => setStep(InvitationStep.chooseGuestType)
      : undefined;

  if (step === InvitationStep.inviteContributors) {
    return (
      <ModalInviteUsers
        userType="contributor"
        handleClose={handleClose}
        handleBack={handleBack}
        handleConfirm={() => {
          if (withVaultSelection) {
            handleClose();
            showSuccessToast();
            handleFinishProcess?.();
          } else {
            setStep(InvitationStep.inviteContributorsConfirmation);
          }
        }}
        withVaultSelection={withVaultSelection}
        preselectedVault={preselectedVault}
      />
    );
  }
  if (step === InvitationStep.inviteContributorsConfirmation) {
    return (
      <ModalInviteConfirmation
        userType="contributor"
        onClickInviteGuests={() => setStep(InvitationStep.inviteGuests)}
        onClickInviteContributors={() =>
          setStep(InvitationStep.inviteContributors)
        }
        handleClose={handleClose}
        handleFinishProcess={handleFinishProcess}
      />
    );
  }
  if (step === InvitationStep.inviteGuests) {
    return (
      <ModalInviteUsers
        userType="guest"
        handleClose={handleClose}
        handleBack={handleBack}
        handleConfirm={() => {
          if (withVaultSelection) {
            handleClose();
            showSuccessToast();
            handleFinishProcess?.();
          } else {
            setStep(InvitationStep.inviteGuestsConfirmation);
          }
        }}
        withVaultSelection={withVaultSelection}
        preselectedVault={preselectedVault}
      />
    );
  }
  if (step === InvitationStep.inviteGuestsConfirmation) {
    return (
      <ModalInviteConfirmation
        userType="guest"
        onClickInviteGuests={() => setStep(InvitationStep.inviteGuests)}
        onClickInviteContributors={() =>
          setStep(InvitationStep.inviteContributors)
        }
        handleClose={handleClose}
        handleFinishProcess={handleFinishProcess}
      />
    );
  }

  return (
    <ModalChooseGuestType
      onClickInviteGuests={() => setStep(InvitationStep.inviteGuests)}
      onClickInviteContributors={() =>
        setStep(InvitationStep.inviteContributors)
      }
      handleClose={handleClose}
    />
  );
};

export { InviteToRecordProcess };
